// The picker's presets: the oklch hues of Tailwind's 500 shades. Only the hue is stored, so custom hues can be
// added later without changing the API.
export const AVATAR_COLORS = {
    red: 25,
    orange: 48,
    amber: 70,
    yellow: 86,
    lime: 131,
    green: 150,
    emerald: 162,
    teal: 183,
    cyan: 215,
    sky: 237,
    blue: 260,
    indigo: 277,
    violet: 293,
    purple: 304,
    fuchsia: 322,
    pink: 354,
    rose: 16,
};
export type AvatarColorName = keyof typeof AVATAR_COLORS;

// One of the presets for a text that has no color of its own, e.g. a person's company: the same text always gets the
// same one, ignoring case and spaces around it.
export const hueOf = (text: string) => {
    let hash = 0;
    for (const character of text.trim().toLowerCase()) {
        hash = (hash * 31 + character.codePointAt(0)!) | 0;
    }
    const hues = Object.values(AVATAR_COLORS);
    return hues[Math.abs(hash) % hues.length];
};

// A person's avatar is colored by their company, so who's from which side shows at a glance; without one it's grey.
export const personHue = (person: { company: string | null }) => (person.company ? hueOf(person.company) : null);
